<app-action-button
  (addEvent)="edit($event)"
  (deleteEvent)="openConfirm('delete')"
  [hidden]="(!svc.isDeleteAction && !canCreate) || svc.hideAppButton"
  [isDeleteAction]="svc.isDeleteAction"
  >
</app-action-button>
<app-loading-indicator [isLoading]="svc.isLoading | async"></app-loading-indicator>
@if ((svc.isLoading | async) === false) {
  <app-noitems (clickEmit)="edit(true)" [image]="'nodata'" [isEmpty]="showNoData" [typeName]="typeName" [hasAdd]="canCreate"></app-noitems>
}

@if (!showNoData) {
  <div class="area data-table" id="ItemsArea">
    @if (
      (svc.filterHasChanged | async) || (svc.pageHasChanged | async) || !(showNoData || (svc.isLoading | async))
      ) {
      <app-data-table2
        (actionRequested)="actionRequested($event)"
        (filterChanged)="svc.tableFilterChanged($event)"
        [columnDefinitions]="columnDefs"
        [columnFilters]="svc.columnFilters"
        [rowData]="displayedItems"
        [tableId]="tableId"
        [rowsToggled]="svc.anySelected"
      ></app-data-table2>
    }
  </div>
}

<!-- TODO - uncomment when integrations docs are posted and can be linked to
<div *ngIf="showInfoBubble && showNoData && (svc.isLoading | async) === false" class="infobox-container">
  <div class="infobox pop">
    <div
      (click)="hideInfoBubble()"
      class="close cancel"
      id="CancelXButtonHideHint"
      title="Click here prevent this info bubble from showing again"
    ></div>
    <div>
      <div *ngIf="!hideZiggy" class="smartziggy">
        <ng-lottie [options]="lottieOptions"></ng-lottie>
      </div>
      <span class="infotitle">{{ infoBubbleTitle }}</span>
      <span class="infotext">{{ infoBubbleText }}</span>
      <a class="infolink" [href]="infoBubbleUrl" target="_blank">Learn More</a>
    </div>
  </div>
</div> -->
